(function () {
  if (window.__u4CartGroups) return;
  window.__u4CartGroups = true;

  var HAM = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" class="u4-grp-ham-svg"><path d="M2 4.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1 0-1m0 3.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1 0-1m0 3.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1 0-1"/></svg>';
  var CHEV = '<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" class="u4-grp-chev-svg"><path d="M5.5 3.5 10 8l-4.5 4.5"/></svg>';
  var grouping = false;
  var debTimer = null;
  var rafPending = false;

  function ssGet(k, fallback) {
    var v = sessionStorage.getItem(k);
    if (v === null) return fallback;
    return v === '1';
  }
  function ssSet(k, open) { sessionStorage.setItem(k, open ? '1' : '0'); }

  // Resolve a group's open state. The merchant's "open by default" setting (defaultAttr "true"/"false")
  // is the default; sessionStorage remembers the SHOPPER's manual toggle within a session so it
  // survives cart re-renders. Problem: a remembered toggle would otherwise mask a later change to the
  // setting. Fix: store the default the toggle was based on; if the merchant changes the setting,
  // the stored default no longer matches -> we discard the remembered toggle and adopt the new default.
  function resolveOpen(grp, defaultAttr) {
    var key = 'u4_grp_' + grp + '_open';
    var defKey = 'u4_grp_' + grp + '_def';
    var settingOpen = defaultAttr !== 'false';
    if (sessionStorage.getItem(defKey) !== String(defaultAttr)) {
      sessionStorage.setItem(defKey, String(defaultAttr));   // adopt the (new) merchant default
      sessionStorage.setItem(key, settingOpen ? '1' : '0');  // reset remembered toggle to it
      return settingOpen;
    }
    var v = sessionStorage.getItem(key);
    return v === null ? settingOpen : (v === '1');
  }

  function makeHeader(grp, label, count, open) {
    var tr = document.createElement('tr');
    tr.className = 'u4-grp-header' + (open ? ' is-open' : '');
    tr.setAttribute('role', 'row');
    tr.setAttribute('data-grp', grp);
    tr.innerHTML =
      '<span class="u4-grp-ham">' + HAM + '</span>' +
      '<span class="u4-grp-label">' + label + '</span>' +
      '<span class="u4-grp-count">(' + count + ')</span>' +
      '<span class="u4-grp-chev">' + CHEV + '</span>';
    return tr;
  }

  // Update an EXISTING header in place (count + open state) instead of recreating it — recreating
  // on every cart re-render made the ☰ icon + label flash (disappear/reappear) like a bug.
  function updateHeader(header, count, open) {
    // a reused header is repositioned via appendChild; if it still had the entrance class, moving it
    // would replay the animation (a blink). Strip it so only genuinely-new headers animate.
    header.classList.remove('u4-grp-header--enter');
    var cnt = header.querySelector('.u4-grp-count');
    if (cnt) cnt.textContent = '(' + count + ')';
    header.classList.toggle('is-open', open);
  }

  // Play the configurable entrance effect (fade / slide / scale) on a header — only when it first appears.
  function animateHeaderEnter(header) {
    header.classList.remove('u4-grp-header--enter');
    void header.offsetWidth; // restart the animation
    header.classList.add('u4-grp-header--enter');
  }

  // Open/close a group with a SMOOTH, proportional slide+fade.
  // The old approach transitioned max-height 1200px->0, so the visible collapse only happened in
  // the final ~10% of the duration (looked like an instant blink). Here we measure each row's real
  // height (scrollHeight) and animate max-height between that exact value and 0, so the whole
  // duration is a real slide. opacity/padding/margin fade via the CSS attribute rule in parallel.
  function setRowsState(tbody, grp, open, animate) {
    var attr = grp === 'items' ? 'data-u4-items-collapsed' : 'data-u4-gifts-collapsed';
    var sel = grp === 'items' ? '.u4-grp-row-items' : '.u4-grp-row-gifts';
    var rows = Array.prototype.slice.call(tbody.querySelectorAll(sel));

    // Clear the one-time entrance/exit animation classes. A finished `u4-gift-reveal`
    // (animation-fill-mode: both) keeps holding max-height:340px and, because CSS animations
    // override inline styles, it would block the inline max-height we set for the collapse —
    // breaking the FIRST collapse/expand right after gifts appear. Removing it hands max-height
    // control back to our JS slide.
    rows.forEach(function (row) { row.classList.remove('u4-gift-reveal', 'u4-gift-leaving'); });

    if (!animate) {
      // instant restore (used on every cart re-render) — no transition, snap to resting state
      rows.forEach(function (row) {
        row.style.transition = 'none';
        row.style.maxHeight = '';
        void row.offsetWidth;
        row.style.transition = '';
      });
      if (open) tbody.removeAttribute(attr); else tbody.setAttribute(attr, '');
      return;
    }

    if (!open) {
      // COLLAPSE: lock each row at its real height, then animate to 0
      rows.forEach(function (row) { row.style.maxHeight = row.scrollHeight + 'px'; });
      void tbody.offsetWidth;            // commit the explicit heights
      tbody.setAttribute(attr, '');      // fades opacity/padding/margin (CSS) in parallel
      rows.forEach(function (row) { row.style.maxHeight = '0px'; });
    } else {
      // EXPAND: measure each row's TRUE natural height first (with its final padding/margin)
      // using a transition-free probe, then animate max-height 0 -> that height. Measuring while
      // the row is still collapsed (padding 0) under-measures the target, so the row "pops" the
      // last pixels at the end ("abre de uma vez / trava no final"). This probe avoids that snap.
      // All the measure/reset happens synchronously (no paint in between) so there is no flicker.
      rows.forEach(function (row) { row.style.transition = 'none'; row.style.maxHeight = ''; });
      tbody.removeAttribute(attr);                       // natural state (instant, no transition)
      var naturals = rows.map(function (row) { return row.offsetHeight; });
      tbody.setAttribute(attr, '');                      // back to collapsed (instant)
      rows.forEach(function (row) { row.style.maxHeight = '0px'; });
      void tbody.offsetWidth;                             // commit collapsed start
      rows.forEach(function (row) { row.style.transition = ''; }); // re-enable transitions
      void tbody.offsetWidth;
      tbody.removeAttribute(attr);                       // un-collapse -> opacity/padding/margin animate
      rows.forEach(function (row, idx) {
        if (!naturals[idx]) { row.style.maxHeight = ''; return; } // layout not ready -> show naturally, no broken cap
        row.style.maxHeight = naturals[idx] + 'px';      // animate 0 -> accurate natural height
        var done = function (ev) {
          if (ev && ev.propertyName && ev.propertyName !== 'max-height') return;
          row.style.maxHeight = '';      // release so the row can grow naturally afterwards
          row.removeEventListener('transitionend', done);
        };
        row.addEventListener('transitionend', done);
      });
    }
  }

  function group(root) {
    var container = root.querySelector('.cart-items[data-u4-group="true"]') || (root.matches && root.matches('.cart-items[data-u4-group="true"]') ? root : null);
    if (!container) {
      // grouping disabled or not present -> ensure no leftover headers
      (root.querySelectorAll ? root : document).querySelectorAll && document.querySelectorAll('.u4-grp-header').forEach(function (h) { h.remove(); });
      return;
    }
    var table = container.querySelector('.cart-items__table');
    var tbody = table && table.querySelector('tbody');
    if (!tbody) return;

    var rows = Array.prototype.slice.call(tbody.querySelectorAll('.cart-items__table-row'));
    var gifts = rows.filter(function (r) { return r.classList.contains('cart-items__table-row--free-gift'); });
    var items = rows.filter(function (r) { return !r.classList.contains('cart-items__table-row--free-gift'); });

    // REUSE existing headers (don't remove+recreate — that made the ☰ + label flicker on every
    // re-render). Find them in place; we'll update/reposition them instead.
    var itemsHeader = tbody.querySelector('.u4-grp-header[data-grp="items"]');
    var giftsHeader = tbody.querySelector('.u4-grp-header[data-grp="gifts"]');

    if (gifts.length === 0) {
      // no gifts -> plain list, remove our headers + clear artifacts
      if (itemsHeader) itemsHeader.remove();
      if (giftsHeader) giftsHeader.remove();
      rows.forEach(function (r) { r.classList.remove('u4-grp-row-items', 'u4-grp-row-gifts', 'u4-grp-row-items--last'); });
      tbody.removeAttribute('data-u4-items-collapsed');
      tbody.removeAttribute('data-u4-gifts-collapsed');
      if (window.__u4HdrSeen) { window.__u4HdrSeen.items = false; window.__u4HdrSeen.gifts = false; } // groups gone -> animate again next time
      return;
    }

    grouping = true;

    var itemsLabel = container.getAttribute('data-u4-items-label') || 'Your items';
    var giftsLabel = container.getAttribute('data-u4-gifts-label') || 'Free gifts';
    var itemsOpen = resolveOpen('items', container.getAttribute('data-u4-items-open'));
    var giftsOpen = resolveOpen('gifts', container.getAttribute('data-u4-gifts-open'));

    items.forEach(function (r) { r.classList.add('u4-grp-row-items'); r.classList.remove('u4-grp-row-gifts', 'u4-grp-row-items--last'); });
    gifts.forEach(function (r) { r.classList.add('u4-grp-row-gifts'); r.classList.remove('u4-grp-row-items'); });
    // mark the final items row (it sits right above the Free gifts header) so CSS can strip the
    // large trailing margin/padding/divider that would otherwise leave a big empty gap before gifts
    if (items.length) { items[items.length - 1].classList.add('u4-grp-row-items--last'); }

    // reuse or create; entrance effect plays ONLY for a genuinely-new header. The entrance class is
    // added at CREATION (before the element is inserted/painted) so the header is born at opacity:0
    // and fades in — adding it after insertion caused a visible flash ("aparece, pisca, depois anima").
    // Animate a header's entrance ONLY the first time its group appears — not on later re-renders.
    // The cart morph wipes our JS-injected headers, so group() recreates them on every update;
    // re-animating each time is exactly the flash the shopper sees.
    var seen = window.__u4HdrSeen || (window.__u4HdrSeen = { items: false, gifts: false });
    if (itemsHeader) updateHeader(itemsHeader, items.length, itemsOpen);
    else { itemsHeader = makeHeader('items', itemsLabel, items.length, itemsOpen); if (!seen.items) itemsHeader.classList.add('u4-grp-header--enter'); }
    seen.items = true;
    if (giftsHeader) updateHeader(giftsHeader, gifts.length, giftsOpen);
    else { giftsHeader = makeHeader('gifts', giftsLabel, gifts.length, giftsOpen); if (!seen.gifts) giftsHeader.classList.add('u4-grp-header--enter'); }
    seen.gifts = true;

    // reorder: items group first, then gifts group at the bottom (moves existing nodes -> no flicker)
    var frag = document.createDocumentFragment();
    if (items.length) { frag.appendChild(itemsHeader); items.forEach(function (r) { frag.appendChild(r); }); }
    frag.appendChild(giftsHeader); gifts.forEach(function (r) { frag.appendChild(r); });
    tbody.appendChild(frag);

    setRowsState(tbody, 'items', itemsOpen, false);
    setRowsState(tbody, 'gifts', giftsOpen, false);

    // smooth reveal of the WHOLE gifts section (header + rows together) when a gift was just unlocked.
    // This reveal takes over the gifts-header entrance, so drop the generic enter class to avoid two
    // conflicting animations fighting on the same element.
    if (window.__u4GiftReveal && giftsOpen) {
      giftsHeader.classList.remove('u4-grp-header--enter');
      giftsHeader.classList.add('u4-grp-reveal');
      gifts.forEach(function (r) { r.classList.remove('u4-gift-leaving'); r.classList.add('u4-gift-reveal'); });
    }
    window.__u4GiftReveal = false;

    setTimeout(function () { grouping = false; }, 60);
  }

  function onHeaderClick(e) {
    var header = e.target.closest && e.target.closest('.u4-grp-header');
    if (!header) return;
    var grp = header.getAttribute('data-grp');
    var tbody = header.closest('tbody');
    if (!tbody) return;
    var attr = grp === 'items' ? 'data-u4-items-collapsed' : 'data-u4-gifts-collapsed';
    var willOpen = tbody.hasAttribute(attr); // currently collapsed -> will open
    setRowsState(tbody, grp, willOpen, true);
    header.classList.toggle('is-open', willOpen);
    ssSet(grp === 'items' ? 'u4_grp_items_open' : 'u4_grp_gifts_open', willOpen);
  }
  document.addEventListener('click', onHeaderClick);

  function scheduleGroup() {
    if (grouping || rafPending) return;
    // Re-group BEFORE the next paint (rAF) instead of after a 120ms timeout. A cart morph (ours OR
    // the theme's native +/-) wipes our JS-injected headers; a 120ms delay let the browser paint the
    // header-less frame — that's the flicker. rAF re-adds them in the same frame the morph paints in.
    rafPending = true;
    var run = function () { rafPending = false; group(document); };
    if (window.requestAnimationFrame) requestAnimationFrame(run); else setTimeout(run, 0);
  }

  function init() {
    group(document);
    // re-group whenever the cart drawer / cart page re-renders (morph)
    var targets = ['.cart-drawer__inner', '.cart-items'];
    targets.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (node) {
        if (node.__u4grpObs) return;
        node.__u4grpObs = true;
        new MutationObserver(function () { scheduleGroup(); }).observe(node, { childList: true, subtree: true });
      });
    });
  }

  // Let the rewards module run grouping SYNCHRONOUSLY right after it morphs the drawer, so the
  // grouped layout (headers in place) is painted in one frame — no un-grouped flash / header pop.
  window.__u4Group = function () { try { group(document); } catch (e) {} };

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  setTimeout(init, 1200);
})();
